import React from "react";
import { CtaButton } from "./CtaButton";
import { PianoKeys } from "./PianoKeys";
export function FinalCta() {
  return <>
      <section className="bg-ebony" aria-labelledby="final-title" data-id="element-81" data-mp="vgqxak5cx4gz">
        <div className="mx-auto max-w-4xl px-5 py-24 text-center md:py-32" data-id="element-82" data-mp="19f7ex64rcfdw">
          <h2 id="final-title" className="font-display text-5xl uppercase leading-[0.98] text-linen md:text-7xl" data-id="element-83" data-mp="15dlv10tt30u7">
            Votre prochain cours peut déjà être{" "}
            <span className="text-brass" data-id="element-84" data-mp="1eebm5r84g31l">organisé</span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl font-serif text-xl italic text-sand/80" data-id="element-85" data-mp="1ebxtfp0wz2x7">
            Guide théorique + guide pratique + 5 bonus pour seulement 27 USD, avec 10 jours
            de garantie.
          </p>
          <div className="mt-10 flex justify-center" data-id="element-86" data-mp="223mhuuam778v">
            <CtaButton variant="brass" data-id="element-87" data-mp="2245ze9wcrtmd" />
          </div>
        </div>
        <PianoKeys octaves={5} className="h-12 md:h-16" data-id="element-88" data-mp="1x5b6gf4o8ooj" />
      </section>
      <footer className="bg-walnut-deep py-8" data-id="element-89" data-mp="n5m7g5iysa3g">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-5 text-sm text-sand/80 md:flex-row" data-id="element-90" data-mp="n6w6oy1jzobo">
          <p data-id="element-91" data-mp="s6s2ia03k9g5">© 2026 Le Pack Prof de Piano. Tous droits réservés.</p>
          <p className="flex gap-6" data-id="element-92" data-mp="x2z9m648bqzo">
            <a href="#" className="transition-colors duration-150 hover:text-linen" data-id="element-93" data-mp="x64wrftasisr">Conditions</a>
            <a href="#" className="transition-colors duration-150 hover:text-linen" data-id="element-94" data-mp="120imp2p6xxq1">Confidentialité</a>
            <a href="#" className="transition-colors duration-150 hover:text-linen" data-id="element-95" data-mp="162m8ol9hkkpk">Contact</a>
          </p>
        </div>
      </footer>
    </>;
}